import { IsArray, IsDefined, IsISO8601, IsNotEmpty, Matches } from 'class-validator';

export class StockLevelFinalizePastDto {
  @IsDefined()
  @IsArray()
  @IsNotEmpty()
  stockCategoryIdList: number[];

  @IsDefined()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  countedDate?: string;
}